/*
 * service to check for numbers
 * to another component
*/
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
class CyString 
{
    static capitalize
    (
        str
    ) : string
    {
        return str && str[0].toUpperCase() + str.slice(1);
    }

    static capitalizeSentence
    (
        sentence
    ) : string
    {
        let i;
        let parts;
        let part;
        let capSentence;
        
        parts = sentence.split(' ');
        
        for (i=0;i<parts.length;i++)
        {
            part = CyString.capitalize(parts[i]);
        
            if (i==0)
            {
                capSentence = part;
            }
            else
            {
                capSentence += ' ' + part;
            }
        }
        
        return capSentence;
    }
}

export { CyString }